module.exports = __webpack_public_path__ + "static/james-brown-lg-1d270daf3094d9a79d1c527dfb3f9601.png";